<template>
  <div class="floor">
    <img
      :src="require('@/assets/images/floor.gif')"
      alt=""
      draggable="false"
      class="image"
    />
    <figure class="coins">
      <img
        v-for="index in 4"
        :key="index"
        :src="require('@/assets/images/coin.gif')"
        alt=""
        draggable="false"
        :class="`coin coin-${index}`"
      />
    </figure>
    <svg class="board" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 115.57 140.08"><path fill="#222" d="M53.11 70.04h5.84v70.04h-5.84z"/><path fill="#222" d="M4.09 5.25h111.48v70.63H4.09z"/><path fill="#fff" d="M0 0h111.48v70.63H0z"/><path fill="#222" d="M68.7 23.66v-7.63h-17v7.63h-4.59v23.6h4.59v7.37h17v-7.37H55.98V23.67"/><path fill="#222" d="M42.03 36.9h22.5v6.19h-22.5zm0-9.64h22.5v6.19h-22.5z"/></svg>
  </div>
</template>

<script>
import { TimelineMax, Power1 } from 'gsap'

export default {
  name: 'Floor',
  mounted () {
    const scene = this.$scrollmagic.scene({
      triggerElement: '.floor',
      triggerHook: 1,
      offset: 350
    })

    const timeline = new TimelineMax()
      .fromTo('.board', 0.5, {
        autoAlpha: 0,
        y: 25,
        ease: Power1.easeOut
      }, {
        autoAlpha: 1,
        y: 0
      }, 0)
      .fromTo('.coins', 0.5, {
        autoAlpha: 0,
        y: 75,
        ease: Power1.easeOut
      }, {
        autoAlpha: 1,
        y: 0
      }, 0)

    this.$scrollmagic.addScene(
      scene.setTween(timeline)
    )
  }
}
</script>

<style lang="scss" scoped>
.floor {
  position: relative;
  margin: 40px auto -20px;
  text-align: center;
  width: 300px;

  @media (min-width: 768px) {
    width: 400px;
    margin: 60px auto 0;
  }
}

.image {
  width: 300px;
  height: 300px;

  @media (min-width: 768px) {
    width: 400px;
    height: 400px;
  }
}
.coins {
  position: absolute;
  top: 58px;
  left: 50%;
  transform: translateX(-50%);
  width: 350px;
  margin: 0 auto;

  @media (min-width: 768px) {
    top: 98px;
  }
}

.coin {
  width: 23px;
  height: auto;
  position: absolute;

  &-1, {
    left: 50px;
    top: 20px;
  }

  &-2 {
    left: 80px;
    top: -40px;
  }

  &-3 {
    right: 120px;
    top: -60px;
  }

  &-4 {
    right: 60px;
    top: 10px;
  }
}

.board {
  top: 66px;
  width: 70px;
  height: 85px;
  position: absolute;
  margin: 0 auto;
  left: 0;
  right: 0;

  @media (min-width: 768px) {
    width: 80px;
    height: 97px;
    top: 103px;
  }
}
</style>
